import { Project } from "interfaces";

import Tag from "ui-components/Tag";

import * as flowConfig from "flows/text-mining/config";
import { projectIsTextMining } from "flows/text-mining/interfaces";

const ContextSummary = ({ project }: { project: Project }) => {
  if (!projectIsTextMining(project)) {
    return null;
  }

  const wsId = project.workspaces[0]?.workspace;

  return (
    <div className="m-1">
      <p>
        Text Columns which have been Analyzed:{" "}
        <span className="underline">
          {project.meta_data[flowConfig.TEXT_COLUMNS_KEY].join(", ")}
        </span>
      </p>
      {wsId && (
        <div className="flex flex-wrap">
          <Tag bgColorClass="bg-primary-main" textColorClass="text-gray-100">
            Model Built
          </Tag>
        </div>
      )}
    </div>
  );
};

export default ContextSummary;
